import React from 'react';
import { ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function itemName(item, materials) {
  return item.name
    || materials.find((me) => Number(me.id) === Number(item.id))?.name
    || `#${item.id}`;
}

function itemMeta(item, materials) {
  const catalog = materials.find((me) => Number(me.id) === Number(item.id));
  const type = item.type || catalog?.type || '';
  const unit = item.unit || catalog?.unit || 'kom';
  return [type, unit].filter(Boolean).join(' · ');
}

export default function SiteStockList({ items, materials }) {
  const { t } = useTranslation();

  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('siteStock.empty')}
      </Typography>
    );
  }

  return (
    <>
      {items.map((item) => (
        <ListItem key={item.id} divider disableGutters>
          <ListItemText
            primary={`${itemName(item, materials)} — ${item.quantity}`}
            secondary={itemMeta(item, materials)}
          />
        </ListItem>
      ))}
    </>
  );
}
